import React, { RefObject } from 'react';

import { merge, cloneDeep } from 'lodash';

import {
  DeepPartial,
  Tokens,
  VKHRTekUIProvider as VKHRTekThemeProvider,
} from '@vk-hr-tek/ui/Theme';

import { useIsWidget } from '@app/hooks';
import { useTheme, useVKHRTekUIServices } from '@app/config';

import { useCustomTheme } from './hooks';

interface ThemeProviderProps {
  children: React.ReactNode | React.ReactNode[];
  portalContainerRef?: RefObject<HTMLDivElement>;
  tokens?: DeepPartial<Tokens>;
}

export const VKHRTekUIProvider = ({
  children,
  portalContainerRef,
  tokens: tokensOverride,
}: ThemeProviderProps) => {
  const theme = useTheme();
  const isWidget = useIsWidget();
  const custom = useCustomTheme();
  const tokens = merge(cloneDeep(tokensOverride), custom);
  const services = useVKHRTekUIServices();

  return (
    <VKHRTekThemeProvider
      portal={portalContainerRef}
      theme={theme}
      useContainerQuery={isWidget}
      tokens={tokens}
      services={services}
    >
      {children}
    </VKHRTekThemeProvider>
  );
};
